import { ViewportScroller } from '@angular/common';
import { Injectable, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, distinctUntilKeyChanged, filter } from 'rxjs';

/**
 * Manually control scrollPositionRestoration
 **/
@Injectable({
  providedIn: 'root',
})
export class ScrollRestorationService {
  private preventNext = true;
  constructor(private router: Router, private viewportScroller: ViewportScroller) {
    /** Scroll page to top on navigation end change */
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      if (!this.preventNext) {
        this.viewportScroller.scrollToPosition([0, 0]);
      }
      this.preventNext = false;
    });
  }

  /** Prevent scroll restoration on next navigation event */
  prevent() {
    this.preventNext = true;
  }
}
